
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/sinch-messagemedia",
      function () {
        return require("private-next-pages/destinations/sinch-messagemedia.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/sinch-messagemedia"])
      });
    }
  